import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import queryString from 'query-string';
import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import Collapsible from 'react-collapsible';
import { StickyContainer, Sticky } from 'react-sticky';
import Scroll from 'react-scroll';
import { checkHttpStatus, parseJSON, formatNumber } from '../../utils';
import { setCurrentSection } from '../../actions/globalConfig';
import {
  Loader,
  LiveCamResult,
  LiveCamVideoResult,
  BlogPostResult,
  SnapshotResult,
  UserResult
} from '../../components';
import './styles.scss';

const propTypes = {
  statusText: PropTypes.string,
  userName: PropTypes.string,
  sectionName: PropTypes.string,
  profileImage: PropTypes.string,
};

const defaultProps = {
  sectionName: 'search',
  statusText: '',
  userName: '',
  profileImage: 'https://explore.org/images/icon_avatar_default.png',
};

class SearchView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      queryResults: {},
      query: _.get(this.props, 'params.term', null),
      isSearching: false,
      isLoadingMoreSnapshots: false,
      snapshotsPage: 2,
      videoOpen: true,
      videoFilmOpen: true,
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.updateQuery = this.updateQuery.bind(this);
    this.loadMoreSnapshots = this.loadMoreSnapshots.bind(this);
    this.closeSearch = this.closeSearch.bind(this);
    this.handleVideoPlays = this.handleVideoPlays.bind(this);
    this.pauseVideo = this.pauseVideo.bind(this);
    this.pauseFilmVideo = this.pauseFilmVideo.bind(this);
    this.playingVideo = null;
    this.playingFilmVideo = null;
  }

  fetchSearchResults(query) {
    query = decodeURIComponent(query);
    this.setState({ isSearching: true });
    var params = queryString.stringify({ q: query });
    return fetch(`${SERVER_URL}/search_results.json?${params}`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(function (response) {
        this.setState({ 'queryResults': response.data, isSearching: false });
      }.bind(this))
      .catch((error) => {
        console.log(error, 'An error occurred');
        this.setState({ isSearching: false });
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  }

  componentWillMount() {
    let query = this.props.params.term;
    if (query) {
      this.fetchSearchResults(query);
    }
    this.props.dispatch(setCurrentSection(this.props.sectionName));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.term !== nextProps.params.term) {
      this.fetchSearchResults(nextProps.params.term);
      this.setState({ query: nextProps.params.term });
    }
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      browserHistory.push('/search/' + encodeURIComponent(e.currentTarget.value));
    }
  }

  updateQuery(e) {
    this.setState({ query: e.target.value });
  }

  closeSearch() {
    let path = (this.props.previousPath) ? this.props.previousPath : '/livecams';
    browserHistory.push(path);
  }

  goToSection(sectionClass) {
    console.log(sectionClass);
    if ($('.' + sectionClass)
      .hasClass('is-closed')) {
      $('.' + sectionClass)
        .find('.trigger-header')
        .trigger('click');
    }
    const positionToMatch = $('.search-results-type')
      .offset().top - $(window)
      .scrollTop();
    var scrollTopPx = $('.result-type-header.' + sectionClass)
      .offset().top - positionToMatch;

    Scroll.animateScroll.scrollTo(scrollTopPx, {
      smooth: true,
    });
  }

  loadMoreSnapshots() {
    if (this.state.isLoadingMoreSnapshots) return;

    let query = decodeURIComponent(this.state.query);
    this.setState({ isLoadingMoreSnapshots: true });
    var params = queryString.stringify({ q: query, page: this.state.snapshotsPage });
    return fetch(`${SERVER_URL}/get_search_paginate.json?${params}`)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then(function (response) {
        let searchResults = this.state.queryResults;
        if (searchResults.snapshots) {
          searchResults.snapshots.push(...response.data.snapshots);
        }
        this.setState({ 'queryResults': searchResults, isLoadingMoreSnapshots: false });
      }.bind(this))
      .catch((error) => {
        console.log(error, 'An error occurred');
        this.setState({ isLoadingMoreSnapshots: false });
        return Promise.resolve(); // TODO: we need a promise here because of the tests, find a better way
      });
  }

  handleVideoPlays(videoReference) {
    if (!_.isNull(this.playingVideo) && videoReference.a !== this.playingVideo.a) {
      this.playingVideo.pauseVideo();
    }
    this.playingVideo = videoReference;
  }

  handleVideoFilmPlays(videoReference) {
    if (!_.isNull(this.playingFilmVideo) && videoReference.a !== this.playingFilmVideo.a) {
      this.playingFilmVideo.pauseFilmVideo();
    }
    this.playingFilmVideo = videoReference;
  }

  pauseVideo() {
    this.setState({ videoOpen: !this.state.videoOpen });
    if (!_.isNull(this.playingVideo)) {
      this.playingVideo.pauseVideo();
    }
  }

  pauseFilmVideo() {
    this.setState({ videoFilmOpen: !this.state.videoFilmOpen });
    if (!_.isNull(this.playingFilmVideo)) {
      this.playingFilmVideo.pauseFilmVideo();
    }
  }

  render() {
    const { feeds, total_feeds, films, total_films, blog_posts, total_blog_posts, snapshots, total_snapshots, videos, total_videos, users, total_users } = this.state.queryResults;
    const { isLoadingMoreSnapshots } = this.state;
    const goToSection = this.goToSection;
    const pauseVideo = this.pauseVideo;
    return (
      <div id="search-page" className="transition-item results-listing-page">
        <div className="search-box">
          <span className="close-search" onClick={this.closeSearch}><i className="icon-X_Close_Square"></i></span>
          <input className="search-field text-center" placeholder="SEARCH EXPLORE" value={this.state.query}
                 onChange={this.updateQuery} onKeyPress={this.handleKeyPress}/>
        </div>
        <div className="container-fluid content pt-90 u-font-foundation-roman">
          <div className={this.state.isSearching ? 'search-loading-container' : 'search-loading-container no-opacity'}>
            <div style={{ marginTop: 200, marginBottom: 200 }}><Loader ref="loader" dark style={{ minHeight: 100 }}/>
            </div>
          </div>
          <StickyContainer
            className={this.state.isSearching ? 'row results-wrapper no-opacity' : 'row results-wrapper'}>
            <div className="col-sm-4 d-none d-sm-block">
              <Sticky topOffset={-140}>
                {
                  ({
                     style,
                     distanceFromBottom,
                     calculatedHeight,
                   }) => {
                    let heightFromTop = 140;
                    if (style && distanceFromBottom && calculatedHeight) {
                      style = (distanceFromBottom < 0 + heightFromTop + 10) ? _.extend(style, {
                        top: 'auto',
                        position: 'absolute',
                        bottom: 10,
                        left: 15,
                      }) : _.extend(style, { top: heightFromTop });
                    }
                    return (
                      <div style={style}>
                        <div
                          className="search-results-type text-uppercase u-textSize-18 container-top-rounded active d-flex justify-content-between">
                          Content Type <span className="u-font-foundation-light">Results</span>
                        </div>
                        <div className="search-results-type category text-uppercase u-textSize-18"
                             onClick={(e) => goToSection('livecams')}>
                          Livecams <span
                          className="float-right u-font-foundation-light">{formatNumber(total_feeds)}</span>
                        </div>
                        {parseInt(total_films, 10) > 0 && (
                          <div className="search-results-type category text-uppercase u-textSize-18"
                               onClick={(e) => goToSection('films')}>
                            Films <span
                            className="float-right u-font-foundation-light">{formatNumber(total_films)}</span>
                          </div>
                        )}
                        {parseInt(total_videos, 10) > 0 && (
                          <div className="search-results-type category text-uppercase u-textSize-18"
                               onClick={(e) => goToSection('livecam-videos')}>
                            Livecam Videos <span
                            className="float-right u-font-foundation-light">{formatNumber(total_videos)}</span>
                          </div>
                        )}
                        {parseInt(total_blog_posts, 10) > 0 && (
                          <div className="search-results-type category text-uppercase u-textSize-18"
                               onClick={(e) => goToSection('blogs')}>
                            Blogs <span
                            className="float-right u-font-foundation-light">{formatNumber(total_blog_posts)}</span>
                          </div>
                        )}
                        {parseInt(total_users, 10) > 0 && (
                          <div className="search-results-type category text-uppercase u-textSize-18"
                               onClick={(e) => goToSection('members')}>
                            Members <span
                            className="float-right u-font-foundation-light">{formatNumber(total_users)}</span>
                          </div>
                        )}
                        {parseInt(total_snapshots, 10) > 0 && (
                          <div className="search-results-type category text-uppercase u-textSize-18"
                               onClick={(e) => goToSection('snapshots')}>
                            Snapshots <span
                            className="float-right u-font-foundation-light">{formatNumber(total_snapshots)}</span>
                          </div>
                        )}
                      </div>
                    );
                  }
                }
              </Sticky>
            </div>
            <div className="col-sm-8 pl-0">
              {feeds && feeds.length > 0 && (
                <Collapsible
                  trigger={(<span className="trigger-header"><span className="panel-title pr-10">Livecams</span> <span
                    className="u-font-foundation-light pl-5">{`${formatNumber(total_feeds)}`}</span></span>)}
                  open={true}
                  triggerClassName="result-type-header livecams text-uppercase  container-rounded u-textSize-18 mb-10"
                  triggerOpenedClassName="result-type-header livecams is-open text-uppercase  container-top-rounded u-textSize-18 mb-10"
                  contentOuterClassName="info-box-content u-textSize-18"
                  contentInnerClassName="results-inner-wrapper"
                >
                  {feeds && feeds.map((feed, index) => {
                    return (
                      <LiveCamResult key={index} className="row search-result-item" feed={feed}/>
                    );
                  })}
                </Collapsible>
              )}
              {films && films.length > 0 && (
                <Collapsible
                  trigger={(<span className="trigger-header"><span className="panel-title pr-10">Films</span> <span
                    className="u-font-foundation-light pl-5">{`${formatNumber(total_films)}`}</span></span>)}
                  open={this.state.videoFilmOpen}
                  triggerClassName="result-type-header films text-uppercase  container-rounded u-textSize-18 mb-10"
                  triggerOpenedClassName="result-type-header films is-open text-uppercase  container-top-rounded u-textSize-18 mb-10"
                  contentOuterClassName="info-box-content u-textSize-18"
                  contentInnerClassName="results-inner-wrapper"
                  handleTriggerClick={this.pauseFilmVideo}
                >
                  {films && films.map((film, index) => {
                    return (
                      <LiveCamVideoResult key={`${film.video_id}-${index}`} video={film}
                                          tracker={this.handleVideoPlays}/>
                    );
                  })}
                </Collapsible>
              )}
              {videos && videos.length > 0 && (
                <Collapsible
                  trigger={(
                    <span className="trigger-header"><span className="panel-title pr-10">Livecam Videos</span> <span
                      className="u-font-foundation-light pl-5">{`${formatNumber(total_videos)}`}</span></span>)}
                  open={this.state.videoOpen}
                  triggerClassName="result-type-header livecam-videos text-uppercase  container-rounded u-textSize-18 mb-10"
                  triggerOpenedClassName="result-type-header livecam-videos is-open text-uppercase  container-top-rounded u-textSize-18 mb-10"
                  contentOuterClassName="info-box-content u-textSize-18"
                  contentInnerClassName="results-inner-wrapper"
                  handleTriggerClick={this.pauseVideo}
                >
                  {videos && videos.map((video, index) => {
                    return (
                      <LiveCamVideoResult key={`${video.video_id}-${index}`} video={video}
                                          tracker={this.handleVideoPlays}/>
                    );
                  })}
                </Collapsible>
              )}
              {blog_posts && blog_posts.length > 0 && (
                <Collapsible
                  trigger={(
                    <span className="trigger-header"><span className="panel-title pr-10">Blogs</span> <span
                      className="u-font-foundation-light pl-5">{`${formatNumber(total_blog_posts)}`}</span></span>)}
                  open={true}
                  triggerClassName="result-type-header blogs text-uppercase  container-rounded u-textSize-18 mb-10"
                  triggerOpenedClassName="result-type-header blogs is-open text-uppercase  container-top-rounded u-textSize-18 mb-10"
                  contentOuterClassName="info-box-content u-textSize-18"
                  contentInnerClassName="results-inner-wrapper"
                >
                  {blog_posts && blog_posts.map((blog, index) => {
                    return (
                      <BlogPostResult key={index} blog={blog}/>
                    );
                  })}
                </Collapsible>
              )}
              {users && users.length > 0 && (
                <Collapsible
                  trigger={(<span className="trigger-header"><span className="panel-title pr-10">Members</span> <span
                    className="u-font-foundation-light pl-5">{`${formatNumber(total_users)}`}</span></span>)}
                  open={true}
                  triggerClassName="result-type-header members text-uppercase  container-rounded u-textSize-18 mb-10"
                  triggerOpenedClassName="result-type-header members is-open text-uppercase  container-top-rounded u-textSize-18 mb-10"
                  contentOuterClassName="info-box-content u-textSize-18"
                  contentInnerClassName="results-inner-wrapper"
                >
                  {users && users.map((user, index) => {
                    return (
                      <UserResult key={index} user={user}/>
                    );
                  })}
                  {users && users.length < total_users &&
                  <div className="members-search-alert u-font-foundation-roman">
                    There are {formatNumber(total_users)} results for that search.<br/>
                    Please be more specific with the search term to find a member.
                  </div>
                  }
                </Collapsible>
              )}
              {snapshots && snapshots.length > 0 && (
                <Collapsible
                  trigger={(<span className="trigger-header"><span className="panel-title pr-10">Snapshots</span> <span
                    className="u-font-foundation-light pl-5">{`${formatNumber(total_snapshots)}`}</span></span>)}
                  open={true}
                  triggerClassName="result-type-header snapshots text-uppercase  container-rounded u-textSize-18 mb-10"
                  triggerOpenedClassName="result-type-header snapshots is-open text-uppercase  container-top-rounded u-textSize-18 mb-10"
                  contentOuterClassName="info-box-content u-textSize-18"
                  contentInnerClassName="results-inner-wrapper"
                >
                  <div className="row snapshots-results">
                    {snapshots && snapshots.map((snapshot, index) => {
                      return (
                        <SnapshotResult key={index} snapshot={snapshot}/>
                      );
                    })}
                    {isLoadingMoreSnapshots &&
                    <Loader ref="loader" dark style={{ height: 100 }}/>
                    }
                    {snapshots && snapshots.length < total_snapshots && !isLoadingMoreSnapshots &&
                    <div className="load-snapshots-button" onClick={this.loadMoreSnapshots}>Load More Snapshots</div>
                    }
                  </div>
                </Collapsible>
              )}
            </div>
          </StickyContainer>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    userName: state.auth.userName,
    statusText: state.auth.statusText,
    previousPath: state.globalConfig.previousPath
  };
};

SearchView.propTypes = propTypes;
SearchView.defaultProps = defaultProps;

export default connect(mapStateToProps)(SearchView);
